import React from 'react';

import LetterTile from '@widgets/letter-tile.jsx';
import LoadSpinner from '@widgets/load-spinner.jsx';

import styles from './account-logo.module.css';
import Button from '@lib/button/button.jsx';

export default class AccountLogo extends React.PureComponent {
  render() {
    const user = this.props.user || {};

    return (
      <div className={styles.userWrapper}>
        <Button className={styles.user} onClick={this.props.onUserSettings}>
          <span className={styles.userName}>{user.name}</span>
          <LoadSpinner show={this.props.loading} className={styles.spinner} />
          <div className={styles.avatarBox}>
            <LetterTile
              authorizeURL={user.authorizeURL}
              avatar={user.avatar || true}
              topic={user.id}
              title={user.name}
            />
          </div>
        </Button>
      </div>
    );
  }
}
